import React from 'react';
import { tabsType } from '../libs/typeInterface';
// import AboutFacialKit from './Kit/AboutFacialKit';
import AboutFcfw from './Kit/AboutFcfw';
import AboutFsfw from './Kit/AboutFsfw';
import AboutFullKit from './Kit/AboutFullKit';

interface IMiddleSection {
  productSelected: string;
  tabs: tabsType[];
  // tslint:disable-next-line: no-any
  inside: any;
}

const MiddleSection = (props: IMiddleSection) => {
  const { productSelected, tabs, inside } = props;

  return (
    <>
      <div className="lg:mt-20 w-full flex justify-center flex-wrap relative overflow-hidden">
        {productSelected === 'face-cream-face-wash' && (
          <AboutFcfw tabs={tabs} inside={inside} productSelected={productSelected} />
        )}
        {productSelected === 'face-serum-face-wash' && (
          <AboutFsfw tabs={tabs} inside={inside} productSelected={productSelected} />
        )}
        {productSelected === 'face-brightening-kit' && (
          <AboutFullKit tabs={tabs} inside={inside} productSelected={productSelected} />
        )}
        {/* {productSelected === 'skin-brightening-facial-kit' && (
          <AboutFacialKit tabs={tabs} inside={inside} productSelected={productSelected} />
        )} */}
      </div>
    </>
  );
};

export default MiddleSection;
